import { apiRequest } from './client'

export type ProfilePlan = {
  planName: string
  expiresAt: string
  balanceCredits: number
  monthlyQuota: number
}

export type ProfilePointLog = {
  id: number
  at: string
  title: string
  delta: number
  balanceAfter: number
}

export type ProfileMeResponse = {
  publicId: string
  nickname: string
  phone: string | null
  status: string
  pointsBalance: number
  createdAt: string
  lastLoginAt: string
  plan: ProfilePlan
  logs: ProfilePointLog[]
  totalLogs: number
  page: number
  size: number
}

export type UpdateProfilePayload = {
  nickname: string
}

export function getProfileMe(page = 1, size = 8) {
  const q = new URLSearchParams({
    page: String(page),
    size: String(size),
  })
  return apiRequest<ProfileMeResponse>(`/v1/profile/me?${q.toString()}`)
}

export function updateProfileMe(payload: UpdateProfilePayload, page = 1, size = 8) {
  const q = new URLSearchParams({
    page: String(page),
    size: String(size),
  })
  return apiRequest<ProfileMeResponse>(`/v1/profile/me?${q.toString()}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  })
}
